module.exports = __webpack_public_path__ + "img/img_takashi_face.d5e47b34.webp";